import { render, staticRenderFns } from "./IncompatibleBrowser.vue?vue&type=template&id=6f5b21ec&scoped=true&"
import script from "./IncompatibleBrowser.vue?vue&type=script&lang=js&"
export * from "./IncompatibleBrowser.vue?vue&type=script&lang=js&"
import style0 from "./IncompatibleBrowser.vue?vue&type=style&index=0&id=6f5b21ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b21ec",
  null
  
)

export default component.exports